export default "__VITE_ASSET__043913e6__"